import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { LoginMenu } from './api-authorization/LoginMenu';
import './NavMenu.css';

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  render () {
    return (
      <header>
        {/* <nav class="navbar navbar-expand-lg navbar-light fixed-top
            font-weight-bold grad-bg-1 text-uppercase">
            <div class="container-fluid">
                <a class="navbar-brand" target="_blank" href="/">
                    <img
                    class="img rounded"
                    src="~/img/logo.png" 
                    width="140px"
                    alt="Angelic shipping logo"
                    loading="lazy"
                    style={{"margin-top: -3px;": "background-color: rgba(255,255,255,0.8)"}}
                    />
                </a>
                <button
                    class="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarExample01"
                    aria-controls="navbarExample01"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarExample01">
                    <ul class="navbar-nav mr-auto mb-2 mb-lg-0">
                    <li class="nav-item active">
                        <a class="nav-link text-white" href="/">Home</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link text-white" href="/About">About</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link text-white" href="/Services">Services</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link text-white" href="/BookingRequest">Booking Request</a>
                    </li> 
                    <li class="nav-item mr-3">
                        <a class="nav-link text-white" href="/Contact">Contact Us</a>
                    </li>
                    <li class="nav-item dropdown mr-3 my-lg-0">
                        <button type="button" class="nav-link text-uppercase bg-dark dropdown-toggle text-white" 
                            id="navbarDropdownMenuLink-Tracking" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">Track Shipments
                        </button>
                        <ul class="dropdown-menu dropdown-default" aria-labelledby="navbarDropdownMenuLink-Tracking">
                            <li><a class="dropdown-item" href="https://www.net.grimaldi.co.uk/GNET45/Pages_RoroTracking/WFRoroTracking"
                                target="_blank">Grimaldi</a></li>
                            <li><a class="dropdown-item" href="https://sallaumlines.com/" target="_blank">Sallaum Lines</a></li>
                            <li><a class="dropdown-item" href="https://www.msc.com/track-a-shipment?link=9fd67ef8-ecc7-419d-8b4d-75e99802b66a" 
                                target="_blank">MSC</a></li>
                            </ul>
                    </li>
                    <li class="nav-item dropdown my-sm-1 my-lg-0">
                        <button type="button" class="nav-link text-uppercase bg-dark dropdown-toggle text-white"  
                            id="navbarDropdownMenuLink-Schedule" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">Schedule
                        </button>
                        <div class="dropdown-menu dropdown-default" aria-labelledby="navbarDropdownMenuLink-Schedule">
                            <a class="dropdown-item" href="https://www.net.grimaldi.co.uk/webdata/Published_Sched_Fleetpos/sched_wa_cex.htm?TS=20160615135731587"
                                target="_blank">Grimaldi</a>
                            <a class="dropdown-item" href="https://sallaumlines.com/schedules/europe-to-west-africa/" target="_blank">Sallaum Lines</a>
                            <a class="dropdown-item" href="https://www.msc.com/search-schedules?link=e57aa6ea-61e8-470e-a206-7d4fdf431bcd"
                                target="_blank">MSC</a>
                        </div>
                    </li>

                    </ul>
                    <ul class="navbar-nav list-inline">
                    <li class="dropdown-notification">
                        <a class="nav-link" href="">
                        <i class="fas fa-shopping-cart"></i>
                        <span class="badge rounded-pill badge-notification bg-danger">1</span>
                        </a>
                    </li>
                    <li class="">
                        <a
                            href="https://www.facebook.com/Angelicsolutionspot"
                            class="btn btn-primary m-1"
                            role="button"
                            rel="nofollow"
                            target="_blank"
                            >
                            <i class="fab fa-facebook-f"></i>
                        </a>
                    </li>                    
                    </ul>
                </div>
            </div>
        </nav>
       */}
      
        <Navbar className="navbar navbar-expand-lg navbar-light fixed-top font-weight-bold grad-bg-1 text-uppercase">
          <Container>
            <NavbarBrand >
              <strong className="text-light">Form submission</strong>
              {/* <image className="logo-img" src={myImg }/> */}
            </NavbarBrand>
            {/* <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
            <Collapse className="collapse navbar-collapse" isOpen={!this.state.collapsed} navbar>
              <ul className="navbar-nav mr-auto mb-2 mb-lg-0">
                <NavItem>
                  <NavLink tag={Link} className="text-white" to="/">Home</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} className="text-white" to="/About">About</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} className="text-white" to="/Services">Services</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} className="text-white" to="/BookingRequest">Booking Request</NavLink>
                </NavItem>
                <NavItem className="mr-3">
                  <NavLink tag={Link} className="text-white" to="/Contact">Contact Us</NavLink>
                </NavItem>
                <NavItem className="dropdown mr-3 my-lg-0">
                  <button dropdownToggle type="button" className="nav-link dropdown-toggle btn btn-dark text-light" data-toggle="dropdown" id="Navbar-Dropdown-Tracking"
                            aria-haspopup="true" aria-expanded="false">Tracking</button >
                    <ul className="dropdown-menu dropdown-default" aria-labelledby="Navbar-Dropdown-Tracking">
                    <li><a className="dropdown-item" href="https://www.net.grimaldi.co.uk/GNET45/Pages_RoroTracking/WFRoroTracking"
                        target="_blank" rel="noopener noreferrer">
                          Grimaldi</a></li>
                    <li><a className="dropdown-item" href="https://sallaumlines.com/" target="_blank"
                        rel="noopener noreferrer">
                          Sallaum Lines</a></li>
                    <li><a className="dropdown-item" href="https://www.msc.com/track-a-shipment?link=9fd67ef8-ecc7-419d-8b4d-75e99802b66a" 
                        target="_blank" rel="noopener noreferrer" >
                          MSC</a></li>
                    </ul>
                </NavItem>
              </ul>
            </Collapse>
           */}</Container>
        </Navbar>
      </header>
    );
  }
}
